import { useRef, useState } from 'react'
import useLoading from '@hooks/useLoading'


const useCheckButton = ({ getDataOnClick, ignoreNewPostsCheck=false }) => {
  //// Check New Posts Button State
  // state for check button loading. it only gets set once the button is actually clicked
  const { isLoading: isPostsCheckableLoading, setIsLoading: setIsPostsCheckableLoading, isLoadingDelayed: isPostsCheckableLoadingDelayed } = useLoading()
  // reset on timeout se we know when to display "check posts" message
  const [isNewPostsCheckable, setIsNewPostsCheckable] = useState(false)
  // timeout that toggles the check button checkable state
  const checkNewPostsTimeout = useRef(null)
  // message to display in check button for results of query
  const [checkBtnMessage, setCheckBtnMessage] = useState('')

  const setCheckPostsTimeout = (delay) => {
    setIsNewPostsCheckable(false)
    clearTimeout(checkNewPostsTimeout.current)
    checkNewPostsTimeout.current = setTimeout(() => {
      setIsNewPostsCheckable(true)
      // 1 minutes -> 60_000ms
      // 5 minutes -> 300_000ms
    }, delay || 300_000)
  }

  const displayCheckBtnMessage = (message) => {
    setCheckBtnMessage(message)
    setTimeout(() => setCheckBtnMessage(''), 2000)
  }

  const newPostsAreFound = (newPosts, oldPosts) => {
    const firstNew = new Date(newPosts[0]?.createdAt)
    const firstOld = new Date(oldPosts[0]?.createdAt)
    return (firstNew && firstNew > firstOld) || !firstOld
  }

  const getDataOnCheck = ({ oldData }) => {
    setIsNewPostsCheckable(false)
    setIsPostsCheckableLoading(true)
    return new Promise((resolve) => {
      getDataOnClick()
        .then((res) => {
          // compare newest post returned, with newest post in feed
          if (ignoreNewPostsCheck || newPostsAreFound(res.data, oldData)) {
            displayCheckBtnMessage('Posts loaded')
            resolve(res.data)
            // if newer posts found, then set new posts and scroll feed to top.
          } else {
            resolve(null)
            displayCheckBtnMessage('🫧 Nothing new yet')
            // handle no new posts: leave posts alone, and render "nothing new yet" (etc) message
          }
        })
        .finally(() => {
          setCheckPostsTimeout()
          setIsPostsCheckableLoading(false)
        })
        .catch(console.log)
    })
  }

  return {
    isPostsCheckableLoading,
    setIsPostsCheckableLoading,
    isPostsCheckableLoadingDelayed,

    isNewPostsCheckable,
    setIsNewPostsCheckable,

    checkNewPostsTimeout,
    setCheckPostsTimeout,

    checkBtnMessage,
    displayCheckBtnMessage,

    newPostsAreFound,
    getDataOnCheck,
  }
}

export default useCheckButton
